import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import _ from "lodash";
import { getTranslation } from "helpers/common";

import { Done, DragHandle } from "components/Icons";
import ToggleSwitch from "components/ToggleSwitch";
import IColumn from "models/IColumn";

interface ISortableItem {
  item: IColumn;
  index: number;
  onSwitchClick: () => void;
  disabled: boolean;
}

interface ISortableList {
  items: IColumn[];
  onSwitchClick: (numnber) => void;
  onSortEnd: (...props) => any;
  lockAxis: string;
  lockToContainerEdges: boolean;
  distance: number;
  helperClass: string;
}

const SortableItem: React.ComponentClass<ISortableItem> = SortableElement(
  ({ item: { key, title, visible = false, fixedWidth }, onSwitchClick }) => (
    <div key={key} className="sortable-list-table-row">
      <div className="big-cell">
        <DragHandle /> {_.upperCase(title ? getTranslation(title) : key)}
      </div>
      <div className="small-cell">{fixedWidth && <Done />}</div>
      <div className="small-cell">
        <ToggleSwitch on={visible} onClick={onSwitchClick} />
      </div>
    </div>
  )
);

const SortableList: React.ComponentClass<ISortableList> = SortableContainer(
  ({ items, onSwitchClick }) => (
    <div className="table-body">
      {items.map((item, index) => (
        <SortableItem
          key={_.uniqueId(item.key)}
          item={item}
          index={index}
          disabled={!!item.fixedWidth}
          onSwitchClick={() => onSwitchClick(index)}
        />
      ))}
    </div>
  )
);

export default SortableList;
